import { TextField } from '@chronosphereio/chrono-ui';
import { produce } from 'immer';
import { useCallback } from 'react';
import { StatusHistoryStepOption, StatusHistoryThresholdOptions } from '@/core';
import {
  ThresholdsEditor,
  ThresholdsEditorProps,
} from '@/plugin-editor-components/components/ThresholdsEditor/NewThresholdsEditor';

export const StatusHistoryThresholdsEditor = ({
  thresholds,
  onChange,
  hideThresholdMode,
}: {
  thresholds?: StatusHistoryThresholdOptions;
  onChange: (newThresholds: StatusHistoryThresholdOptions) => void;
  hideThresholdMode: boolean;
}) => {
  const props: ThresholdsEditorProps<StatusHistoryStepOption, StatusHistoryThresholdOptions> = {
    onChange,
    renderStepOptions: ({ step, onStepChange }) => {
      return <StatusHistoryThresholdStepEditor step={step} onStepChange={onStepChange} />;
    },
    thresholds,
    hideThresholdMode,
    isValueMapping: true,
  };

  return <ThresholdsEditor {...props} />;
};

function StatusHistoryThresholdStepEditor<T extends Omit<StatusHistoryStepOption, 'value'>>({
  step,
  onStepChange,
}: {
  step: T;
  onStepChange: (newStep: T) => void;
}) {
  const handleLabelChange = useCallback(
    (newLabel: string) => {
      onStepChange(
        produce(step, (draft) => {
          return { ...draft, name: newLabel };
        })
      );
    },
    [step, onStepChange]
  );

  return (
    <TextField
      defaultValue={step.name || ''}
      label="Label"
      fullWidth
      onBlur={(event) => handleLabelChange(event.currentTarget.value)}
    />
  );
}
